import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.fund.list.formed');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-fund-list-formed',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.fund.list.formed/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminFundListFormedComponent implements OnInit {
    @Input() view: any;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.view == "admin") await this.service.auth.allow.membership(['admin', 'super_admin'], "/landing");
        else await this.service.auth.allow(true, "/landing");
        await this.load();
    }

    public loading: boolean = false;
    public templateDownloading: boolean = false;
    public exporting: boolean = false;
    public importing: boolean = false;
    public list: any = [];
    public search: any = {
        text: "",
        page: 1,
        dump: 10000000
    }

    public pagination: any = {
        end: -1,
        start: -1,
        current: 0
    }

    public gradeStyle: any = {
        'S': 'bg-blue-100 text-blue-800',
        'A': 'bg-emerald-100 text-emerald-800',
        'B': 'bg-yellow-100 text-yellow-800',
        'C': 'bg-orange-100 text-orange-800',
        'D': 'bg-red-100 text-red-800'
    };

    private excelApi(action: string): string {
        return wiz.url(action);
    }

    private async downloadExcel(action: string, filename: string) {
        const response = await fetch(this.excelApi(action), {
            method: 'POST',
            body: new FormData(),
            credentials: 'same-origin'
        });
        const contentType = (response.headers.get('content-type') || '').toLowerCase();
        const blob = await response.blob();
        if (!response.ok || contentType.includes('application/json') || contentType.includes('text/html') || contentType.includes('text/plain')) {
            const text = (await blob.text()).trim();
            try {
                const json = JSON.parse(text);
                const code = json?.code ? `API error ${json.code}` : `HTTP ${response.status}`;
                const message = json?.data?.message || json?.message || '';
                throw new Error(message ? `${code}: ${message}` : code);
            } catch (e) {
                if (!(e instanceof SyntaxError)) throw e;
                throw new Error(text ? `HTTP ${response.status}: ${text.slice(0, 200)}` : `HTTP ${response.status}`);
            }
        }
        if (blob.size === 0) throw new Error('Empty response');

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    }

    private excelErrorText(e: any): string {
        const message = e && e.message ? String(e.message).trim() : '';
        return message ? `: ${message.slice(0, 200)}` : '';
    }

    public async load(page: number = 1) {
        if (this.loading) return;
        this.loading = true;
        this.pagination.current = page;
        this.search.page = page;
        this.list = [];
        await this.service.render();

        const { code, data } = await wiz.call("search", this.search);

        if (code == 200) {
            let { rows, lastpage } = data;
            const startpage = Math.floor((page - 1) / 10) * 10 + 1;
            this.list = rows;
            this.pagination.start = startpage;
            this.pagination.end = lastpage;
        }

        this.loading = false;
        await this.service.render();
    }

    public async removeItem(item) {
        let res = await this.service.alert.show({ title: "조합 삭제", message: "조합을 삭제하시겠습니까?", action: "삭제", cancel: "취소", actionBtn: 'error', status: 'error' });
        if (!res) return;
        const { code } = await wiz.call("remove", item);
        if (code !== 200) return this.service.alert.error("조합 삭제 실패");
        await this.load(this.pagination.current);
    }

    public async downloadTemplate() {
        if (this.templateDownloading) return;
        this.templateDownloading = true;
        await this.service.render();

        try {
            const today = new Date().toISOString().slice(0, 10).replace(/-/g, '');
            await this.downloadExcel('template_excel', `결성중인조합_업로드양식_${today}.xlsx`);
        } catch (e) {
            await this.service.alert.error(`엑셀 양식 다운로드 실패${this.excelErrorText(e)}`);
        }

        this.templateDownloading = false;
        await this.service.render();
    }

    public async exportExcel() {
        if (this.exporting) return;
        this.exporting = true;
        await this.service.render();

        try {
            const today = new Date().toISOString().slice(0, 10).replace(/-/g, '');
            await this.downloadExcel('export_excel', `결성중인조합_${today}.xlsx`);
        } catch (e) {
            await this.service.alert.error(`엑셀 다운로드 실패${this.excelErrorText(e)}`);
        }

        this.exporting = false;
        await this.service.render();
    }

    public async importExcel() {
        if (this.importing) return;
        const files = await this.service.file.select({ accept: '.xlsx' });
        if (!files || files.length === 0) return;

        const ok = await this.service.alert.show({
            title: '엑셀 업로드',
            message: `"${files[0].name}" 파일의 조합정보/투자기업정보 시트만 업로드합니다.`,
            action: '업로드',
            cancel: '취소',
            actionBtn: 'warning',
            status: 'warning'
        });
        if (!ok) return;

        this.importing = true;
        await this.service.render();

        try {
            const fd = new FormData();
            fd.append('file', files[0]);
            const response = await fetch(this.excelApi('import_excel'), {
                method: 'POST',
                body: fd,
                credentials: 'same-origin'
            });
            const json = await response.json();
            if (!response.ok || json?.code !== 200) throw new Error(json?.data?.message || 'upload failed');
            await this.showImportResult(json.data?.result || {});
            await this.load(this.pagination.current || 1);
        } catch (e) {
            await this.service.alert.error('엑셀 업로드 실패');
        }

        this.importing = false;
        await this.service.render();
    }

    private async showImportResult(result: any) {
        const message = [
            `조합 생성 ${result.funds_created || 0}건 / 수정 ${result.funds_updated || 0}건`,
            `투자기업 생성 ${result.investments_created || 0}건 / 수정 ${result.investments_updated || 0}건`,
            `기업정보 생성 ${result.companies_created || 0}건 / 수정 ${result.companies_updated || 0}건`,
            `건너뜀 ${result.skipped_rows || 0}건`
        ].join('\n') + ((result.errors || []).length ? `\n\n오류 일부:\n${(result.errors || []).slice(0, 3).join('\n')}` : '');
        await this.service.alert.show({
            title: '엑셀 업로드 완료',
            message,
            action: '확인',
            actionBtn: (result.errors || []).length ? 'warning' : 'success',
            status: (result.errors || []).length ? 'warning' : 'success'
        });
    }
}

export default PortalLpsysadminFundListFormedComponent;